import React from 'react'
import { Field, reduxForm } from 'redux-form';
import { Button, Grid } from '@material-ui/core';
import RenderTextFieldRedux from './RenderTextFieldRedux';

const validate = values => {
    const error  = {}
    if (!values.description) {
        error.description = `El campo es obligatorio.`
    }
    return error
}

const RenderDescriptionForm = props => {
    const { label, handleSubmit, valid, positive, getBack } = props
    return (
        <form onSubmit={ handleSubmit } >
            <Field
                name="description"
                id="description"
                component={ RenderTextFieldRedux }
                label={label}
                fullWidth
                multiline
                //autoFocus = {true}
                rows={3}
            />
            <br></br>
            <Grid container spacing={3}>
                <Grid item xs={6} md={6} lg={6} xl={6}>
                        <Button fullWidth variant="contained" color="primary" disabled={!valid}  type="submit" >{positive}</Button>
                   
                </Grid>
                <Grid item xs={6} md={6} lg={6} xl={6}>
                    
                        <Button fullWidth variant="contained" color="primary" onClick = {() => getBack(true) } style = {{
                                    fontSize: '0.6rem',
                                    color: '#1a1919',
                                    borderLeft: '3px solid rgba(255, 198, 0)',
                                    backgroundColor: "white",
                                    borderRadius: '0px',
                                    fontFamily: 'Ubuntu',
                                    fontWeight: 'bold'
                                }}>Cancelar</Button>
                    
                </Grid>
            </Grid>
        </form>
    );
}

const RenderDescriptionFormRedux = reduxForm(
    {
        form: 'RenderDescriptionForm',
        validate
    }
)(RenderDescriptionForm)

export default RenderDescriptionFormRedux